import type { StructuredReportResponse } from "../hooks/useReportQuery";

/**
 * Pick the series carrying the most report evidence.
 *
 * Drafter can emit findings across several reconstructed series and does not
 * always populate model.selectedSeriesId. Counting report links gives the
 * viewer a deterministic clinical priority without anatomy- or model-specific
 * rules. Ties keep first report order.
 */
export function reportPrioritySeriesId(
  report: Pick<StructuredReportResponse, "sections" | "toConsider"> | null | undefined,
): string | null {
  if (!report) return null;

  const counts = new Map<string, number>();
  const consider = (seriesId: string | null | undefined) => {
    if (!seriesId) return;
    counts.set(seriesId, (counts.get(seriesId) ?? 0) + 1);
  };

  for (const section of Object.values(report.sections)) {
    for (const finding of section.findings) consider(finding.seriesId);
  }
  for (const finding of report.toConsider) consider(finding.seriesId);

  let selected: string | null = null;
  let selectedCount = 0;
  for (const [seriesId, count] of counts) {
    if (count > selectedCount) {
      selected = seriesId;
      selectedCount = count;
    }
  }
  return selected;
}
